 export interface ActiveUser{
    id: string,
    name: string,
    email: string,
    role: 'admin' | 'user' | 'Ing. de Campo' | 'Tecnico Campo'
  }
  
  export enum DepartmentNameEnum {
    wellWhisper = '33909508-729a-11ef-b5c1-c9abfae58c0d',
    rig = 'rig',
    tanks = 'tanks',
    gasMeasure = 'gasMeasure',
  }
  
  export enum BaseStatusEntityEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DELETED = 'DELETED',
    LOCKED = 'LOCKED',
  }
  
  export interface Project {
    id:string,
    code:string,
    name:string,
    status:BaseStatusEntityEnum,
  }

  export interface ProjectList {
    id:string,
    name:string,
    projectId?:string,
  }
  
  export interface ActiveDepartment {
    id:string,
    code:string,
    name:string,
    status:BaseStatusEntityEnum,
    projects: Project[],
  }

  export interface Subtask {
    id:string,
    status:BaseStatusEntityEnum,
    resourceLink:string,
    process:string,
    errors:string[],
  }

  export interface File {
    id:string,
    status:BaseStatusEntityEnum,
    detail:string,
    url_link:string,
    subtask: Subtask,
  }

  export interface TeamMember {
    id:string,
    name:string,
    email:string,
  }

  export interface ErrorDetail {
    type: string;
    field: string;
    message: string;
}

export interface UserDetail {
    email: string;
    name: string;
}

  export interface TaskList{
    id: string;
    name: string;
    description: string | null;
    state: string;
    errors: ErrorDetail[];
    originFiles: any[]| null;
    originFlow: string;
    createdAt: string;
    updatedAt: string;
    user: UserDetail;
    totalActivities: number;
}

  export interface ListOfActivities {
    id:string,
    location:string,
    status:string,
    completedAt:Date,    
    activityType:string,
    opeStatus:string,
    cardPath:string,
  }

  export interface ListOfLocationsToAnalyst {
    id:string,
    name:string,
    status:string,
    completedAt:Date,
    pot:string,
    activityType:string,
    opeStatus:string,
    activities:ListOfActivities[],
    hasCardsToAnalyze:boolean,
  }

  export interface TypesOfActivities {
    id:string,
    label:string,
    deppendOf:string[],
  }

  export interface StatusConditions{
    name:string,
    field:string,
    correctStatus:string[],
    warningStatus:string[],
  }

  export interface ConfigModules {
    enabledUploadModules: string[];
    projectList: ProjectList[];
    typesActivitiesForRequirements: TypesOfActivities[];
    typesActivitiesForOptimization: TypesOfActivities[];
    statusConditions: StatusConditions[];
    optimizationActivitiesStates: string[];
  }
  
  export interface mainSliceState {
    activeDepartmentId?: DepartmentNameEnum|undefined,
    activeProjectId?: string,
    showMenu: boolean,
    activeUser?: ActiveUser,
    loading: boolean,
    showUserMenu: boolean,
    activeDepartment:ActiveDepartment | undefined, 
    usersList: ActiveUser[],
    uploadingStep?: string,
    taskList?: TaskList[],
    notifications?:ToastProps[],
    listOfLocation?: ListOfLocationsToAnalyst[],
    configModules:ConfigModules
  }

  export interface ToastProps {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info';
    duration?: number;
  }